import React from 'react';
import './Partners.css';
import accenture from '../assets/images/partners/accenture.png';
import xoriant from '../assets/images/partners/XORIANT.png';
import bridgestone from '../assets/images/partners/Bridgstone.png';
import ey from '../assets/images/partners/EY.png';
import fcm from '../assets/images/partners/fcm.png';
import integ from '../assets/images/partners/INTEG.png';
import kabi from '../assets/images/partners/KABI.png';
import smartworks from '../assets/images/partners/smartworks.png';

const partners = [
  { name: 'Accenture', img: accenture },
  { name: 'Xoriant', img: xoriant },
  { name: 'Bridgestone', img: bridgestone },
  { name: 'EY', img: ey },
  { name: 'FCM', img: fcm },
  { name: 'INTEG', img: integ },
  { name: 'KABI', img: kabi },
  { name: 'SMARTWORKS', img: smartworks },
];

function Partners() {
  return (
    <section className="partners">
      <div className="partners-slider">
        <div className="partners-track">
          {[...partners, ...partners].map((partner, i) => (
            <div key={i} className="partner-item">
              <img src={partner.img} alt={partner.name} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Partners;
